import { AccountKeyIcon } from './AccountKeyIcon';

/**
 * author: REJack
 * id 645E04E6-A328-45DD-9B22-03E2296837B1
 * name account-key
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-key.svg
 * tags
 * - Account / User 
 */
export const PersonKeyIcon = AccountKeyIcon;
export default PersonKeyIcon